export default __webpack_public_path__ + "static/media/serge-beser.612f376f.png";